import type { AreaCatalog } from '../area';
import type { access as en } from '../en/access';

export const access = {
  'access.dial.options': 'Optionen für {label}',
  'access.dial.confirm': 'Ja, übernehmen',
  'access.visibility.label': 'Sichtbarkeit',
  'access.visibility.private': 'Privat',
  'access.visibility.open': 'Für alle offen',
  'access.visibility.privateWhat':
    'Nur Personen und Gruppen mit einem Weg zu dieser Aufgabe sehen sie (die Grenze der Organisation gilt immer).',
  'access.visibility.openWhat':
    'Alle in diesem Bereich sehen diese Aufgabe: im gemeinsamen Bereich sind das alle auf Tesserano. Zugriffe bleiben protokolliert.',
  'access.visibility.confirm': 'Ja, für alle öffnen',
  'access.inherit.label': 'Zugriff',
  'access.inherit.inheritsState': 'erbt von übergeordneten Aufgaben',
  'access.inherit.brokenState': 'Vererbung unterbrochen',
  'access.inherit.inherits': 'Erbt von übergeordneten Aufgaben',
  'access.inherit.inheritsWhat':
    'Wer Zugriff auf eine übergeordnete Aufgabe hat, sieht auch diese.',
  'access.inherit.confirm': 'Ja, wieder verbinden',
  'access.inherit.broken': 'Vererbung unterbrochen',
  'access.inherit.brokenWhat':
    'Diese Aufgabe bekommt keinen Zugriff mehr von übergeordneten Aufgaben; ab hier abwärts zählen nur direkte Freigaben.',

  'access.panel.addAs': 'Hinzufügen als',
  'access.panel.roleLabel': 'Rolle für die Auswahl',
  'access.panel.cancel': 'Abbrechen',
  'access.panel.apply': 'Übernehmen',
  'access.panel.placeholder': 'Personen und Gruppen hinzufügen…',
  'access.panel.empty': 'Niemand mehr zum Hinzufügen.',
  'access.panel.remove': '{name} entfernen',
  'access.panel.nobody': 'Noch niemand.',

  'access.request.already': 'Schon angefragt.',
  'access.request.done': 'Zugriff angefragt. Die Verantwortlichen sehen die Anfrage im Protokoll.',
  'access.request.line': 'Zugriff als {role} anfragen',
  'access.request.roleLabel': 'Angefragte Rolle',
  'access.request.submit': 'Anfragen',
  'access.request.role.viewer': 'Betrachtende',
  'access.request.role.member': 'Mitglied',
  'access.request.role.owner': 'Verwaltende',

  'access.role.viewer': 'Betrachtende',
  'access.role.member': 'Mitglied',
  'access.role.owner': 'Verwaltende',
  'access.audience.viewerHint': 'sieht hinein',
  'access.audience.memberHint': 'arbeitet damit',
  'access.audience.ownerHint': 'verwaltet alles',
  'access.audience.roleFor': 'Rolle von {name}',
  'access.audience.title': 'Personenkreis',
  'access.audience.titleBoard': 'Personenkreis dieses Boards',
  'access.audience.titleView': 'Personenkreis dieser Ansicht',
  'access.audience.sentenceBoard':
    'Alle hier sehen die Aufgaben auf diesem Board. Mitglieder dürfen Arbeit hinzufügen. Verwaltende konfigurieren es.',
  'access.audience.sentenceView':
    'Alle hier können diese Ansicht öffnen. Sie zeigt jeder Person nur, was sie ohnehin sehen darf. Verwaltende können ihre gespeicherte Einstellung ändern.',
  'access.audience.boardViewer': 'Sieht die Aufgaben',
  'access.audience.boardMember': 'Darf Arbeit hinzufügen und Aufgaben bearbeiten',
  'access.audience.boardOwner': 'Konfiguriert das Board',
  'access.audience.viewViewer': 'Öffnet sie',
  'access.audience.viewOwner': 'Pflegt sie',
  'access.audience.loading': 'Wird geladen…',
  'access.audience.unreachable': 'Nicht erreichbar.',
  'access.audience.footnote': 'Änderungen am Personenkreis stehen im Verlauf.',
  'access.mint.defaultName': '{name} (geteilt)',
  'access.mint.saveTitle': 'Als Board speichern',
  'access.mint.shareTitle': 'Als neues Board teilen',
  'access.mint.saveSubtitle':
    'Ein neues Board mit diesem Filter und dieser Sortierung; „{source}“ bleibt unverändert.',
  'access.mint.shareSubtitle':
    'Ein neues Board auf Basis von „{source}“; die Quelle bleibt unverändert.',
  'access.mint.cancel': 'Abbrechen',
  'access.mint.save': 'Board speichern',
  'access.mint.create': 'Board erstellen',
  'access.mint.name': 'Name',
  'access.mint.nameLabel': 'Name des neuen Boards',
  'access.mint.audienceHint':
    'Wen das neue Board erreicht. Seine Karten sind die Aufgaben, die für diesen Personenkreis freigegeben sind; was nur du sehen kannst, bleibt in der Quelle.',
  'access.share.title': 'Aufgaben teilen',
  'access.share.subtitle': 'Die Aufgaben auf „{view}“ für Personen oder Gruppen freigeben.',
  'access.share.counting': 'Aufgaben auf diesem Board werden gezählt…',
  'access.share.none':
    'Dieses Board enthält für dich keine Aufgaben, also gibt es nichts zu teilen.',
  'access.share.count': {
    one: '{count} Aufgabe auf diesem Board. Sie wird mit deinen eigenen Rechten geteilt; was du nicht teilen darfst, wird übersprungen und hier aufgelistet, nie freigegeben.',
    other:
      '{count} Aufgaben auf diesem Board. Jede wird mit deinen eigenen Rechten geteilt; was du nicht teilen darfst, wird übersprungen und hier aufgelistet, nie freigegeben.',
  },
  'access.share.placeholder': 'Mit Personen und Gruppen teilen…',
  'access.share.viewerHint': 'sieht die Aufgaben',
  'access.share.memberHint': 'arbeitet daran',
  'access.share.ownerHint': 'verwaltet sie mit',
  'access.share.shared': '{count} geteilt',
  'access.share.already': '{count} schon geteilt',
  'access.share.skipped': '{count} übersprungen',
  'access.share.unnamed': 'Eine Aufgabe, die du sehen, aber nicht teilen kannst',
  'access.share.lacks': 'dir fehlen die Rechte, sie zu teilen',
  'access.share.otherOrg':
    'eine gewählte Gruppe gehört zu einer anderen Organisation als diese Aufgabe',
} as const satisfies AreaCatalog<typeof en>;
